export default __webpack_public_path__ + "static/media/mini-logo.8148ef1d.svg";